import { render, staticRenderFns } from "./BilingualNews.vue?vue&type=template&id=7d7d6f94&scoped=true"
import script from "./BilingualNews.vue?vue&type=script&lang=js"
export * from "./BilingualNews.vue?vue&type=script&lang=js"
import style0 from "./BilingualNews.vue?vue&type=style&index=0&id=7d7d6f94&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d7d6f94",
  null
  
)

export default component.exports